import React from "react";
import { useTranslation } from "react-i18next";

import { SECTION_IDS } from "@constants/sectionIds";
import { socialLinks } from "@constants/socialLinks";
import { CONTACT_MAIL } from "@constants/constants";
import { scrollToTop } from "@utils/scrollUtils";

import Link from "@components/toolkit/Link/Link";
import IconLink from "@components/toolkit/IconLink/IconLink";

import "./Footer.scss";

const Footer = () => {
  const { t } = useTranslation("layouts");

  const year = new Date().getFullYear();

  return (
    <footer id={SECTION_IDS.FOOTER} className="footer">
      <img
        aria-hidden="true"
        src="/images/layouts/footer-bg.png"
        alt=""
        width={3317}
        height={2416}
        className="footer__bg-image"
      />

      <div className="footer__content">
        <div className="footer__header">
          <h2 className="green-1">{t("footer.title")}</h2>
          <p className="p0">{t("footer.description")}</p>
        </div>

        <div className="footer__main">
          <div className="footer-card">
            <h3>{t("footer.contactUs")}</h3>

            <div className="contact-link">
              <Link href={`mailto:${CONTACT_MAIL}`} uppercase={false}>
                {CONTACT_MAIL}
              </Link>
            </div>
          </div>

          <div className="footer-card">
            <h3>{t("footer.socialMediaTitle")}</h3>

            <div className="social-links">
              {socialLinks.map(({ href, title, icon }, index) => (
                <IconLink key={index} href={href} title={title} target="_blank">
                  {icon}
                </IconLink>
              ))}
            </div>
          </div>
        </div>

        <div className="footer__rights">
          <button onClick={scrollToTop}>
            <img src="/images/branding/finder-ai-logo-white.svg" alt={t("footer.logoAltTxt")} width={142} height={24} />
          </button>

          <p className="p1">{t("footer.rights", { year })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
